import { render } from "./QuizRunner.vue?vue&type=template&id=049ebeec&scoped=true&ts=true"
import script from "./QuizRunner.vue?vue&type=script&lang=ts"
export * from "./QuizRunner.vue?vue&type=script&lang=ts"

import "./QuizRunner.vue?vue&type=style&index=0&id=049ebeec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049ebeec"]])

export default __exports__